import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ReactUtil } from 'modules/core/services';
import styles from './Label.module.scss';

function Label({
  error,
  label,
  disabled,
  className,
  RightLabelComponent,
  required,
  optional,
  htmlFor,
}) {
  if (!label) {
    return null;
  }

  const labelClasses = classNames(
    'label',
    styles.label,
    error && styles['label--error'],
    disabled && styles['label--disabled'],
    className,
  );

  const labelContent = (
    <>
      {label}
      {required && <span className={styles.required}> (required)</span>}
      {optional && <span className={styles.optional}> (optional)</span>}
    </>
  );

  return (
    <span className={styles.container}>
      {label && htmlFor ? (
        <label htmlFor={htmlFor} className={labelClasses}>
          {labelContent}
        </label>
      ) : (
        <div className={labelClasses}>{labelContent}</div>
      )}
      {ReactUtil.resolveComponent(RightLabelComponent)}
    </span>
  );
}

Label.propTypes = {
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  label: PropTypes.string,
  RightLabelComponent: PropTypes.node,
  optional: PropTypes.bool,
  htmlFor: PropTypes.string,
};

export default memo(Label);
